// extracted by mini-css-extract-plugin
module.exports = {"headerGap":"HorizontalHeader_headerGap__h1ta3","collapseHeaderGap":"HorizontalHeader_collapseHeaderGap__i4JTz"};